import React from 'react';
import { Check, Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { LOCALES } from '../i18n/locales';
import { useContent, useLocale } from '../i18n/LocaleProvider';

export default function LanguageSwitcher({ inline = false }) {
  const { locale, setLocale } = useLocale();
  const { UI } = useContent();
  const active = LOCALES.find((entry) => entry.code === locale) || LOCALES[0];

  if (inline) {
    return (
      <div className="lang-inline" role="group" aria-label={UI.common.language}>
        {LOCALES.map((entry) => (
          <button
            key={entry.code}
            type="button"
            className={`lang-inline__btn ${entry.code === locale ? 'lang-inline__btn--active' : ''}`}
            aria-pressed={entry.code === locale}
            onClick={() => setLocale(entry.code)}
            data-testid={`mobile-lang-${entry.code}`}
          >
            {entry.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="site-header__lang"
          aria-label={UI.common.language}
          data-testid="language-switcher"
        >
          <Globe size={18} aria-hidden="true" />
          <span className="site-header__lang-code">{active.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" collisionPadding={12} className="lang-menu">
        <DropdownMenuLabel className="lang-menu__label">{UI.common.language}</DropdownMenuLabel>
        {LOCALES.map((entry) => (
          <DropdownMenuItem
            key={entry.code}
            onSelect={() => setLocale(entry.code)}
            className="lang-menu__item"
            data-testid={`language-option-${entry.code}`}
          >
            <span>{entry.label}</span>
            {entry.code === locale ? <Check size={15} aria-hidden="true" /> : null}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <p className="lang-menu__note">{UI.common.languageNote}</p>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
